import { defineComponent } from "vue";
import { definePropType } from "@types-vue/props";
import ResourceList from "./resource-list.vue";
import AddResourceToUsed from "./add-resource-to-used.vue";
export default defineComponent({
    props: {
        resources: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        },
        frames: {
            type: Number
        }
    },
    components: {
        ResourceList: ResourceList,
        AddResourceToUsed: AddResourceToUsed
    },
    inject: [
        "show",
        "hide"
    ],
    setup: function setup(props, param) {
        var emit = param.emit;
        var getTargetTypeComponents = function(tags) {
            emit("viewTagAllData", tags);
        };
        var disabledClick = function(res) {
            if (res.payload) {
                return JSON.parse(res.payload).frames < props.frames;
            } else if (res.file_urls) {
                return res.file_urls.length < props.frames;
            }
            return true;
        };
        var handleAddResource = function(res) {
            if (!disabledClick(res)) {
                emit("addResource", res);
            }
        };
        return {
            handleAddResource: handleAddResource,
            getTargetTypeComponents: getTargetTypeComponents,
            disabledClick: disabledClick
        };
    }
});
